import { render, staticRenderFns } from "./DisplaySection.vue?vue&type=template&id=8beb1602"
import script from "./DisplaySection.vue?vue&type=script&lang=ts"
export * from "./DisplaySection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports